import React from "react"

export const EnabledLabFeaturesContext = React.createContext(/** @type {string[]} */ ([]))
